import React, { Component } from "react";
import voiceStore from "../stores/voiceStore";
import Wave from "../components/Wave";
import {
  LuFolderPlus,
  LuLayoutGrid,
  LuHeart,
  LuPlay,
  LuPause,
} from "react-icons/lu";
import { FaCaretRight, FaCaretDown } from "react-icons/fa";
import SearchNav from "../components/SearchNav";
import { observer } from "mobx-react";
import { SearchColoredIcon } from "../assets/icons";
import Button from "../components/Button";
import projectStore from "../stores/projectStore";
import generalStore from "../stores/generalStore";

const SearchResults = observer(
  class SearchResults extends Component {
    state = {
      expandedGroups: {
        0: true,
      },
      windowWidth: window.innerWidth,
      searchNavVisible: true,
    };

    componentDidMount() {
      window.addEventListener("resize", this.handleResize);
      if (window.innerWidth >= 1024) {
        voiceStore.setSearchNavVisible(true);
      }
    }

    componentWillUnmount() {
      window.removeEventListener("resize", this.handleResize);
    }

    handleResize = () => {
      this.setState({ windowWidth: window.innerWidth });

      if (window.innerWidth >= 1024) {
        voiceStore.setSearchNavVisible(true);
      }
    };

    toggleGroup = (index) => {
      this.setState((prevState) => ({
        expandedGroups: {
          ...prevState.expandedGroups,
          [index]: !prevState.expandedGroups[index],
        },
      }));
    };

    handleFavoriteMusic = (sample_id, isFavorite) => () => {
      voiceStore.setFavoriteMusic(sample_id, isFavorite).then((isFavorite) => {
        voiceStore.searchResults = voiceStore.searchResults.map((talent) => {
          talent.voice_data = talent.voice_data.map((voice) => {
            if (voice.sample_id === sample_id) {
              voice.isFavorite = isFavorite;
            }
            return voice;
          });
          return talent;
        });
      });
    };

    renderGroupedTalents() {
      return voiceStore.searchResults.map((talent, index) => {
        const isExpanded = this.state.expandedGroups[index];
        return (
          <div key={talent.talent_id} className="flex flex-col my-5">
            <button
              onClick={() => this.toggleGroup(index)}
              className="flex flex-1 flex-row gap-x-2 lg:gap-x-4 justify-center items-center pl-5"
            >
              <span className="font-medium text-xs lg:text-base text-black flex flex-1">
                {talent.talent_name}
              </span>
              <span className="font-normal text-xs text-white py-1 px-2 rounded-full bg-[#F89A1F]">
                {talent.voice_data.length}
              </span>
              {isExpanded ? (
                <FaCaretDown size={20} />
              ) : (
                <FaCaretRight size={20} />
              )}
              <div className="h-[1.5px] w-[50%] md:w-[80%] bg-[#B7B7B7]"></div>
            </button>

            {isExpanded &&
              talent?.voice_data.map((voice, index) => (
                <div
                  key={talent.talent_id + index}
                  className="flex flex-1 flex-row justify-between items-center border border-l-0 my-2 py-2 px-10"
                >
                  <div className="flex flex-1 flex-row gap-2 items-center">
                    {talent.profile_image_path ? (
                      <img
                        src={
                          process.env.REACT_APP_BASE_URL +
                          "/" +
                          talent.profile_image_path
                        }
                        className="w-10 h-10 rounded-full"
                        alt={talent?.talent_name}
                      />
                    ) : (
                      <div className="w-10 h-10 rounded-full bg-gray-200 flex justify-center items-center text-sm text-black/50">
                        {generalStore.getInitials(talent.talent_name)}
                      </div>
                    )}
                    <div className="flex flex-col justify-center">
                      <span className="font-medium text-sm text-[#21272A]">
                        {voice.tags.accent[0] ? voice.tags.accent[0] : voice.fileName}
                        {console.log(typeof voice.tags.accent)}
                      </span>
                      <span className="font-normal text-xs text-[#697077]">
                        {talent?.talent_name}
                      </span>
                    </div>
                  </div>

                  {/* Conditionally render description based on screen width */}
                  {this.state.windowWidth >= 768 && (
                    <>
                      <div className="flex flex-1 flex-row justify-center items-center">
                        {voice.fileType === "mp4" ? (
                          <button
                            onClick={() => {
                              voiceStore.setVideoModal({
                                fileName: voice.fileName,
                                video: voice.voice_path,
                              });
                            }}
                            className="text-blue-500 underline underline-offset-2"
                          >
                            show video
                          </button>
                        ) : (
                          <Wave
                            clickable={false}
                            id={`${talent.talent_id}-${index}`}
                            audioUrl={voice.voice_path}
                            peaksUrl={voice.voice_modulation_path}
                          />
                        )}
                      </div>
                      <div className="flex flex-1 justify-center">
                        <div className="font-normal text-xs text-[#121619] ml-3">
                          {Object.keys(voice.tags).map((key) => (
                            <div key={key}>
                              {voice.tags[key].map((item, index) => (
                                <span key={index}>
                                  {item} {item && "/"}
                                </span>
                              ))}
                            </div>
                          ))}
                        </div>
                      </div>
                    </>
                  )}

                  <div className="flex flex-row gap-x-3">
                    {voiceStore.isPlaying &&
                    voiceStore.currentVoice?.voice_path === voice.voice_path ? (
                      <button
                        onClick={() => {
                          voiceStore.togglePlayPause(false);
                        }}
                      >
                        <LuPause
                          className="fill-black hover:cursor-pointer"
                          size={18}
                        />
                      </button>
                    ) : (
                      <button
                        onClick={() => {
                          if (voice.fileType === "mp4") {
                            voiceStore.setVideoModal({
                              fileName: voice.fileName,
                              video: voice.voice_path,
                            });
                            return;
                          }
                          if (
                            voiceStore.currentVoice?.voice_path ===
                            voice.voice_path
                          ) {
                            voiceStore.togglePlayPause(true);
                            return;
                          }
                          voiceStore.setCurrentVoice(null);

                          setTimeout(() => {
                            voiceStore.setCurrentVoice({
                              talent_id: talent.talent_id,
                              talent_name: talent.talent_name,
                              voice_path: voice.voice_path,
                              voice_modulation_path:
                                voice.voice_modulation_path,
                              sample_id: voice.sample_id,
                              IsFavorite: voice.isFavorite,
                              profile_image_path: talent.profile_image_path,
                            });
                            voiceStore.togglePlayPause(true);
                          }, 500);
                        }}
                      >
                        <LuPlay
                          className="fill-black hover:cursor-pointer"
                          size={18}
                        />
                      </button>
                    )}

                    <LuHeart
                      onClick={this.handleFavoriteMusic(
                        voice.sample_id,
                        voice.isFavorite
                      )}
                      className={`hover:cursor-pointer hidden lg:flex ${
                        voice.isFavorite === "1" && "fill-[#F89A1F]"
                      }`}
                      size={18}
                    />
                    <LuFolderPlus
                      onClick={() => {
                        projectStore.setAddToProjectModalVisible(true);
                      }}
                      className="hover:cursor-pointer"
                      size={18}
                    />
                    <LuLayoutGrid
                      className="hover:cursor-pointer"
                      onClick={() => {
                        voiceStore.getTalentById(talent.talent_id).then(() => {
                          voiceStore.setTalentDetailsModalVisible(true);
                        });
                      }}
                      fill="black"
                      size={18}
                    />
                  </div>
                </div>
              ))}
          </div>
        );
      });
    }
    render() {
      return (
        <div className="flex flex-row pb-20 bg-white">
          {voiceStore.searchNavVisible && (
            <div className="pt-10">
              <SearchNav></SearchNav>
            </div>
          )}

          <div className="flex flex-1 flex-col mt-10">
            <div className="flex justify-end mx-6 py-3 gap-3 lg:gap-6">
              <Button
                onClick={() => {
                  voiceStore.setSearchNavVisible(true);
                }}
                className="flex  lg:hidden rounded-md"
                icon={SearchColoredIcon}
              />
            </div>

            {voiceStore.searchResults.length === 0 && (
              <div className="flex flex-1 justify-center mt-5">
                <span className="font-medium text-lg text-red-500">
                  No results found
                </span>
              </div>
            )}
            {this.renderGroupedTalents()}
          </div>
        </div>
      );
    }
  }
);

export default SearchResults;
